import { __awaiter, __decorate, __metadata } from 'tslib';
import { EventEmitter, Input, Output, Component, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormGroup, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';
import { TooltipModule } from 'ng2-tooltip-directive';
import { BrMaskerModule } from 'br-mask';

let UiCInputComponent = class UiCInputComponent {
    constructor(storage) {
        this.storage = storage;
        this.hasMasker = false;
        this.dataCyName = '';
        this.isReproved = false;
        this.onBlur = new EventEmitter();
        this.keyup = new EventEmitter();
        this.togglePassword = new EventEmitter();
        this.isDevolution = false;
        this.count = 0;
    }
    ngOnInit() {
        if (this.isDate || this.isCPF || this.isCNPJ || this.isMoney || this.isPhone || this.isCEP || this.isNumber || this.isPerson || this.isEpv || this.isAgency ||
            this.isAccount || this.isPorcentual || this.isPercentWithDigits) {
            this.hasMasker = true;
        }
        this.storage.get('isRetryOnboarding').then(res => {
            this.isDevolution = res;
        });
    }
    change(event) {
        this.onBlur.emit(event);
    }
    checkValue(event) {
        event.target.value = event.target.value.replace(/[A-Za-z]/g, '');
    }
    changeMoney() {
        if (this.isMoney || this.isPercentWithDigits) {
            const control = this.form.get(this.formName);
            if (control.value && typeof control.value === 'string') {
                const sanitizedValue = control.value.replace(/\./g, '').replace(/,/g, '.');
                const sanitizedValueNoLeadingZeros = sanitizedValue.replace(/^0+(?!\.|$)/, '');
                control.patchValue(sanitizedValueNoLeadingZeros);
            }
        }
    }
    changeMasker() {
        this.hasMasker = true;
        /* this.type = 'tel'; */
        if (this.isDate) {
            return { mask: '00/00/0000', len: 10, type: 'num' };
        }
        if (this.isAccount) {
            return { money: true, decimalCaracter: '-', decimal: '1' };
        }
        if (this.isAgency) {
            return { mask: '00000', type: 'num' };
        }
        if (this.isCPF) {
            this.maxlength = '14';
            this.minlength = 14;
            this.type = 'tel';
            return { mask: '000.000.000-00', len: 14, type: "num" };
            /* return { person: true, len: 14 }; */
        }
        if (this.isCNPJ) {
            this.maxlength = '18';
            this.minlength = 18;
            this.type = 'tel';
            return { mask: '00.000.000/0000-00', len: 18 };
            // return { person: true, len: 18 };
        }
        if (this.isMoney || this.isPercentWithDigits) {
            return { money: true, thousand: '.', decimalCaracter: ',', decimal: '2' };
        }
        if (this.isPhone) {
            this.maxlength = '15';
            this.minlength = 15;
            this.type = 'tel';
            return { mask: '(00) 00000-0000', len: 15, type: 'num' };
        }
        if (this.isCEP) {
            this.maxlength = '9';
            this.minlength = 9;
            this.type = 'tel';
            return { mask: '00000-000', len: 9, type: 'num' };
        }
        if (this.isEpv) {
            this.type = 'text';
            return { mask: '00000000-0000-0000-0000-000000000000', len: 36, userCaracters: true, type: 'text' };
        }
        if (this.isNumber) {
            /* this.type = 'tel'; */
            return { len: this.maxlength, type: 'num' };
        }
        if (this.isPerson) {
            return { person: true };
        }
        if (this.isPorcentual) {
            return { len: this.maxlength, type: 'num' };
        }
        this.type = 'text';
        this.hasMasker = false;
        return { mask: false, userCaracters: true };
    }
    togglePass() {
        this.togglePassword.emit();
    }
    onKeyDownPreventInsertSpace(event, value) {
        return __awaiter(this, void 0, void 0, function* () {
            setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                let value = yield this.form.controls[this.formName].value;
                let valueKey = value.substring(value.length - 1);
                if (value.length === 1 && valueKey === ' ') {
                    this.form.controls[this.formName].setValue(value.substring(0, value.length - 1));
                }
                else if (valueKey === ' ') {
                    this.count += 1;
                    if (this.count > 1)
                        this.form.controls[this.formName].setValue(value.substring(0, value.length - 1));
                }
                else {
                    this.count = 0;
                }
            }), 100);
        });
    }
};
__decorate([
    Input(),
    __metadata("design:type", FormGroup)
], UiCInputComponent.prototype, "form", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "formName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "name", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], UiCInputComponent.prototype, "minlength", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "maxlength", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "class", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "placeholder", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "label", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "tooltip", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "type", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "iconName", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], UiCInputComponent.prototype, "dataCyName", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isFloating", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isPorcentual", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isPercentWithDigits", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isDate", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isCPF", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isCNPJ", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isMoney", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isPhone", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isCEP", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isNumber", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isPerson", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isEpv", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isReproved", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isAgency", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "isAccount", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], UiCInputComponent.prototype, "block", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], UiCInputComponent.prototype, "errorMessages", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCInputComponent.prototype, "onBlur", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCInputComponent.prototype, "keyup", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], UiCInputComponent.prototype, "togglePassword", void 0);
UiCInputComponent = __decorate([
    Component({
        selector: 'ui-c-input',
        template: "<form [formGroup]=\"form\">\n  <ion-text class=\"ion-text-left\" *ngIf=\"name\">\n    <p class=\"font-family-bold ion-no-margin margin-bottom color-primary c-text-input\">\n      {{ name }}\n    </p>\n  </ion-text>\n  <ion-item class=\"c-input\">\n\n    <span class=\"icn-holder\" slot=\"end\">\n      <ion-icon name=\"checkmark-circle\" color=\"success\"\n        *ngIf=\"form?.get(formName)?.valid && (form?.get(formName)?.dirty || form?.get(formName)?.touched)\">\n      </ion-icon>\n      <ion-icon name=\"close-circle-outline\" color=\"danger\"\n        *ngIf=\"form?.get(formName)?.invalid && (form?.get(formName)?.dirty || form?.get(formName)?.touched) && !isDevolution\">\n      </ion-icon>\n\n      <ion-icon name=\"close-circle-outline\" color=\"danger\" *ngIf=\"form?.get(formName)?.invalid && isDevolution\">\n      </ion-icon>\n    </span>\n\n    <ion-label class=\"floatingLabel\" [position]=\"isFloating ? 'floating' : null\">\n      {{label}}\n    </ion-label>\n\n    <ng-container *ngIf=\"hasMasker\">\n      <span class=\"icn-holder\" slot=\"start\" *ngIf=\"isMoney && !isFloating\" > R$ </span>\n      <ion-input\n        [type]=\"type? type : 'text'\"\n        [formControlName]=\"formName\"\n        [label]=\"label\" \n        [placeholder]=\"placeholder\" \n        [minlength]=\"minlength\"\n        [maxlength]=\"maxlength\" \n        [ngClass]=\"class\" \n        [disabled]=\"block\" \n        [brmasker]=\"changeMasker()\"\n        (ionBlur)=\"change($event)\" \n        (ionChange)=\"changeMoney()\" \n        (keyup)=\"checkValue($event)\"\n        data-cy=\"{{dataCyName}}\"\n      >\n      </ion-input>\n      <span class=\"icn-holder\" slot=\"end\" *ngIf=\"isPorcentual || isPercentWithDigits\">%</span>\n    </ng-container>\n    <ng-container *ngIf=\"!hasMasker\">\n      <ion-input\n        [formControlName]=\"formName\"\n        [label]=\"label\" \n        [placeholder]=\"placeholder\" \n        [minlength]=\"minlength\" \n        [maxlength]=\"maxlength\"\n        [ngClass]=\"class\" \n        [disabled]=\"block\" \n        (ionBlur)=\"change($event)\" \n        [type]=\"type\"\n        data-cy=\"{{dataCyName}}\"\n      >\n      </ion-input>\n      <ion-icon [name]=\"iconName\" (click)=\"togglePass()\"> </ion-icon>\n    </ng-container>\n  </ion-item>\n\n  <div class=\"error-messages\" *ngIf=\"errorMessages && errorMessages[formName]\">\n    <ng-container *ngFor=\"let error of errorMessages[formName]\">\n      <div class=\"error-message font-family-semibold\"\n        *ngIf=\"form?.get(formName)?.hasError(error?.type) && (form?.get(formName)?.dirty || form?.get(formName)?.touched)\">\n        {{ error?.message | wlpTranslate: error?.param}}\n      </div>\n    </ng-container>\n\n    <div class=\"error-message font-family-semibold\" *ngIf=\"form?.get(formName)?.invalid && isDevolution\">\n      {{ 'ONBORDING.V2.FORM.FIELD_TO_REVISED' | wlpTranslate }}\n    </div>\n  </div>\n</form>\n"
    }),
    __metadata("design:paramtypes", [Storage])
], UiCInputComponent);

let UiCInputModule = class UiCInputModule {
};
UiCInputModule = __decorate([
    NgModule({
        declarations: [UiCInputComponent],
        imports: [
            CommonModule,
            ReactiveFormsModule,
            IonicModule,
            UiBsTranslateModule,
            FormsModule,
            TooltipModule,
            BrMaskerModule,
        ],
        exports: [UiCInputComponent],
        schemas: [
            CUSTOM_ELEMENTS_SCHEMA
        ]
    })
], UiCInputModule);

export { UiCInputComponent, UiCInputModule };
//# sourceMappingURL=wlp-ui-c-input.js.map
